import { FormLabel, Row, Col } from "react-bootstrap";
import { SimpleFormControl } from "../form/SimpleFormControl";
import Pacman from "../layout/Pacman";
import { useField } from "formik";
import { useEffect } from "react";
import { INetlinkingOrderInfo } from "src/app/types/orders/order";

export interface INetlinkingOrderInfoFrom {
    netlinkingOrderInfo?: INetlinkingOrderInfo[];
    loading?: boolean;
    url?: string | null;
}
const NetlinkingOrderInfoFrom = (props: INetlinkingOrderInfoFrom) => {
    const { netlinkingOrderInfo, url, loading = false } = props;
    const [, , netlinkingOrderInfoHelper] = useField("netlinkingOrderInfo");

    useEffect(() => {
        if (!netlinkingOrderInfo) return;
        netlinkingOrderInfoHelper.setValue(netlinkingOrderInfo);
    }, [netlinkingOrderInfo]);

    if (!netlinkingOrderInfo || loading) return <Pacman />;

    return (
        <>
            <Row>
                <Col>
                    <FormLabel>
                        {netlinkingOrderInfo.length} liens pour l'url : {url}
                    </FormLabel>
                </Col>
            </Row>

            {netlinkingOrderInfo?.map((_keyword, index) => {
                return (
                    <Row key={index}>
                        <Row>
                            <hr />
                            <Col sm={1} className="d-flex align-items-center">
                                <FormLabel>KW</FormLabel>
                            </Col>
                            <Col sm={8}>
                                <SimpleFormControl name={`netlinkingOrderInfo.${index}.keyword`} />
                            </Col>
                            <Col sm={3}>
                                <SimpleFormControl
                                    type="date"
                                    name={`netlinkingOrderInfo.${index}.date`}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={1} className="d-flex align-items-center">
                                <FormLabel>Ancre</FormLabel>
                            </Col>
                            <Col sm={11}>
                                <SimpleFormControl name={`netlinkingOrderInfo.${index}.anchor`} />
                            </Col>
                        </Row>
                    </Row>
                );
            })}
        </>
    );
};

export default NetlinkingOrderInfoFrom;
